import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Box, Tooltip, IconButton, Chip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const LazisnuTransactionTable = ({ transactions, onEdit, onDelete }) => {
  const getKategoriName = (t) => t.kategori ? t.kategori.nama : '-';

  return (
    <Box sx={{ overflowX: 'auto' }}>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="lazisnu transaction table">
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>Tanggal</TableCell>
              <TableCell>Kategori</TableCell>
              <TableCell>Deskripsi</TableCell>
              <TableCell>Dibuat Oleh</TableCell>
              <TableCell align="right">Jumlah</TableCell>
              <TableCell align="center">Aksi</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  Tidak ada transaksi.
                </TableCell>
              </TableRow>
            ) : (
              transactions.map((transaction, index) => {
                const isPemasukan = transaction.jenis === 'PEMASUKAN';
                return (
                  <TableRow key={transaction.id} hover>
                    <TableCell component="th" scope="row">
                      {index + 1}
                    </TableCell>
                    <TableCell>{new Date(transaction.tanggal).toLocaleDateString('id-ID')}</TableCell>
                    <TableCell>
                        <Chip 
                            label={getKategoriName(transaction)} 
                            size="small" 
                            color={isPemasukan ? "success" : "warning"} 
                            variant="outlined" 
                        />
                    </TableCell>
                    <TableCell>{transaction.deskripsi}</TableCell>
                    <TableCell>{transaction.user?.username || '-'}</TableCell>
                    
                    <TableCell align="right" sx={{ color: isPemasukan ? 'green' : 'red', fontWeight: 'bold' }}>
                        {isPemasukan ? '+' : '-'} Rp{parseFloat(transaction.jumlah).toLocaleString('id-ID')}
                    </TableCell>

                    <TableCell align="center">
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Tooltip title="Edit Transaksi">
                            <IconButton onClick={() => onEdit(transaction)} color="primary" size="small">
                                <EditIcon />
                            </IconButton>
                            </Tooltip>
                            <Tooltip title="Hapus Transaksi">
                            <IconButton onClick={() => onDelete(transaction.id)} color="error" size="small">
                                <DeleteIcon />
                            </IconButton>
                            </Tooltip>
                        </Box>
                    </TableCell>
                  </TableRow>
                );
              }))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LazisnuTransactionTable;